import React, { FC } from 'react'

type T01LogoProps = Record<string, unknown>

const T01Logo: FC<T01LogoProps> = () => {
  return (
    <svg width="100px" height="100px" fill="none">
      <mask
        id="a"
        style={{
          maskType: 'alpha'
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={100}
        height={100}
      >
        <path
          d="M0 34.883C0 22.544 0 16.375 2.44 11.68a21.667 21.667 0 0 1 9.239-9.24C16.375 0 22.544 0 34.883 0h30.234C77.456 0 83.625 0 88.32 2.44a21.666 21.666 0 0 1 9.24 9.239C100 16.375 100 22.544 100 34.883v30.234c0 12.339 0 18.508-2.44 23.204a21.666 21.666 0 0 1-9.239 9.24C83.625 100 77.456 100 65.117 100H34.883c-12.339 0-18.508 0-23.204-2.44a21.666 21.666 0 0 1-9.24-9.239C0 83.625 0 77.456 0 65.117V34.883Z"
          fill="#C4C4C4"
        />
      </mask>
      <g mask="url(#a)">
        <path fill="#F18D8D" d="M0 0h100v100H0z" />
        <path fill="#fff" d="M0 0h100v100H0z" />
        <g opacity={0.4}>
          <mask
            id="b"
            style={{
              maskType: 'alpha'
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={100}
            height={100}
          >
            <path fill="#fff" d="M0 0h100v100H0z" />
          </mask>
          <g mask="url(#b)">
            <path
              opacity={0.5}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M68.962 88.726a43.331 43.331 0 0 0 11.37-8.1l12.503 12.502H68.962v-4.402Zm-18.75 4.402v-.005a42.855 42.855 0 0 0 18.333-4.192v4.197H50.212Zm-18.75 0V88.93a42.855 42.855 0 0 0 18.333 4.192v.005H31.462Zm-24.285 0 12.5-12.502a43.343 43.343 0 0 0 11.371 8.1v4.402H7.177Zm4.106-24.167a43.335 43.335 0 0 0 8.1 11.371L6.88 92.834V68.96h4.402ZM6.88 50.211h.005a42.855 42.855 0 0 0 4.192 18.334H6.88V50.21Zm0-18.75h4.197a42.857 42.857 0 0 0-4.192 18.334h-.005V31.46Zm0-24.288 12.502 12.5a43.349 43.349 0 0 0-8.1 11.372H6.88V7.172Zm24.167 4.107a43.343 43.343 0 0 0-11.37 8.1L7.175 6.878h23.872v4.402Zm18.747-4.402v.005a42.868 42.868 0 0 0-18.333 4.192V6.878h18.333Zm18.75 0v4.197a42.868 42.868 0 0 0-18.333-4.192v-.005h18.333Zm24.29 0L80.333 19.38a43.331 43.331 0 0 0-11.37-8.1V6.878h23.872Zm-4.106 24.166a43.325 43.325 0 0 0-8.1-11.37L93.13 7.173v23.871H88.73Zm4.402 18.75h-.005a42.857 42.857 0 0 0-4.19-18.333h4.195v18.334Zm0 18.75h-4.196a42.854 42.854 0 0 0 4.191-18.333h.005v18.334Zm-23.873.417h19.001a42.88 42.88 0 0 1-7.926 11.076L69.258 68.961Zm-.296.295L80.04 80.332a42.917 42.917 0 0 1-11.077 7.926V69.256Zm-18.75 7.617c7.103-.055 13.553-2.88 18.333-7.443v19.042a42.448 42.448 0 0 1-18.333 4.234V76.873Zm-18.75-7.443c4.78 4.564 11.23 7.388 18.333 7.443v15.833a42.447 42.447 0 0 1-18.333-4.234V69.43Zm-.414-.173v19.001a42.914 42.914 0 0 1-11.076-7.926l11.076-11.075Zm-.295-.296L19.677 80.037a42.898 42.898 0 0 1-7.926-11.076h19.002Zm-7.617-18.75c.055 7.103 2.879 13.554 7.443 18.334H11.537A42.447 42.447 0 0 1 7.302 50.21h15.834Zm7.443-18.75c-4.564 4.78-7.388 11.231-7.443 18.334H7.302a42.437 42.437 0 0 1 4.235-18.334H30.58Zm.174-.416H11.751a42.912 42.912 0 0 1 7.926-11.076l11.076 11.076Zm.295-.295L19.972 19.674a42.912 42.912 0 0 1 11.076-7.926V30.75Zm18.747-7.617c-7.102.055-13.553 2.879-18.333 7.443V11.534A42.436 42.436 0 0 1 49.795 7.3v15.834Zm18.75 7.443c-4.78-4.564-11.23-7.388-18.333-7.443V7.299a42.437 42.437 0 0 1 18.333 4.235v19.042Zm.417.174V11.748a42.915 42.915 0 0 1 11.077 7.926L68.962 30.75Zm.296.295 11.075-11.076a42.912 42.912 0 0 1 7.926 11.076H69.258Zm7.618 18.75c-.055-7.103-2.88-13.554-7.444-18.334h19.043a42.448 42.448 0 0 1 4.234 18.334H76.876Zm0 .416h15.833a42.448 42.448 0 0 1-4.234 18.334H69.432c4.564-4.78 7.39-11.231 7.444-18.334Zm-26.664 18.75h18.22c-4.72 4.592-11.142 7.44-18.22 7.495v-7.495Zm-.414 0v7.495c-7.077-.055-13.499-2.903-18.22-7.495h18.22Zm-18.751-18.75v18.221c-4.59-4.721-7.44-11.143-7.495-18.22h7.495Zm0-.417h-7.495c.056-7.077 2.904-13.499 7.495-18.22v18.22Zm18.751-18.75h-18.22c4.721-4.59 11.143-7.439 18.22-7.495v7.495Zm.414 0V23.55c7.078.056 13.5 2.904 18.22 7.495h-18.22Zm18.75 18.75v-18.22c4.592 4.721 7.44 11.143 7.495 18.22h-7.495Zm0 .417h7.495c-.055 7.078-2.903 13.5-7.495 18.222V50.211Zm-18.75.295 18.04 18.039h-18.04v-18.04Zm-.416 0v18.039H31.758l18.038-18.038Zm-.295-.295-18.039 18.04V50.21h18.04Zm0-.416H31.462v-18.04l18.04 18.04Zm.295-.295L31.758 31.46h18.038V49.5Zm.416 0V31.462h18.04l-18.04 18.04Zm18.334.711V68.25L50.508 50.21h18.038Zm-18.038-.416 18.038-18.038v18.038H50.508ZM93.13 92.834l-12.5-12.502a43.311 43.311 0 0 0 8.099-11.37h4.401v23.872Zm8.004 8.002-7.291-7.291h6.371v-.417h-6.666V68.961h6.666v-.416h-6.666V50.21h6.666v-.416h-6.666V31.46h6.666v-.416h-6.666V6.878h6.666v-.417h-6.371L100.3.003l-.295-.294-6.458 6.458V-.205h-.417V6.46H68.964V-.205h-.416V6.46H50.214V-.205h-.416V6.46H31.464V-.205h-.416V6.46H6.88V-.205h-.417v6.372L.006-.29-.29.003l6.46 6.458H-.203v.417h6.666v24.167H-.202v.416h6.666v18.334H-.202v.416h6.666v18.334H-.202v.416h6.666v24.167H-.202v.417H6.17l-6.46 6.458.296.295 6.458-6.458v6.371h.417v-6.666h24.167v6.666h.416v-6.666h18.334v6.666h.416v-6.666h18.334v6.666h.416v-6.666h24.167v6.666h.417V93.84l7.291 7.291.295-.295Z"
              fill="#fff"
            />
          </g>
        </g>
        <g opacity={0.4} stroke="#fff" strokeWidth={0.195}>
          <rect
            opacity={0.72}
            x={16.895}
            y={4.395}
            width={66.406}
            height={91.406}
            rx={6.934}
          />
          <rect
            opacity={0.72}
            x={10.645}
            y={10.645}
            width={78.906}
            height={78.906}
            rx={6.934}
          />
          <rect
            opacity={0.72}
            x={4.395}
            y={16.895}
            width={91.406}
            height={66.406}
            rx={6.934}
          />
          <path d="M95.8 50.098C95.8 75.338 75.34 95.8 50.099 95.8S4.395 75.339 4.395 50.098c0-25.241 20.462-45.703 45.703-45.703 25.24 0 45.703 20.462 45.703 45.703Z" />
          <path d="M70.606 50.098c0 11.326-9.182 20.508-20.508 20.508-11.326 0-20.508-9.182-20.508-20.508 0-11.326 9.182-20.508 20.508-20.508 11.326 0 20.508 9.182 20.508 20.508Z" />
          <path d="M35.645 35.645h28.906v28.906H35.645z" />
          <path
            d="M35.645.098v100M50.098 0v100M64.55 0v100M100.098 35.645h-100M100 50.098H0M100.098 64.55h-100M.098.098l100 100M100.098.098l-100 100"
            strokeLinecap="square"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M153.026 50c0 27.613-22.421 49.999-50.079 49.999s-50.08-22.386-50.08-50c0-27.613 22.422-49.998 50.08-49.998 27.658 0 50.079 22.385 50.079 49.999Z"
          fill="#75FABF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M58.725 26.531C66.73 11.53 82.161 1.081 100.124.085 99.644.032 99.16 0 98.665 0h-44.54c-7.338 0-13.287 5.94-13.287 13.266 0 7.325 5.95 13.265 13.288 13.265h4.6Z"
          fill="#42DBA1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M100.125.086C82.162 1.082 66.73 11.53 58.727 26.532h39.94c7.338 0 13.286-5.938 13.286-13.265 0-6.834-5.177-12.456-11.828-13.18Z"
          fill="#00A673"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M52.869 50c0-4.594.633-9.038 1.795-13.265h-18.72c-7.338 0-13.288 5.94-13.288 13.265 0 7.326 5.95 13.264 13.288 13.264h18.72A49.933 49.933 0 0 1 52.87 50Z"
          fill="#42DBA1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M64.52 36.735h-9.857A49.94 49.94 0 0 0 52.867 50c0 4.595.633 9.039 1.796 13.266h9.857c7.338 0 13.286-5.939 13.286-13.266 0-7.325-5.948-13.265-13.286-13.265Z"
          fill="#00A673"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M58.725 73.469h-4.6c-7.338 0-13.287 5.94-13.287 13.265 0 7.326 5.95 13.266 13.288 13.266h44.54c.494 0 .979-.032 1.458-.085-17.963-.996-33.394-11.445-41.399-26.446Z"
          fill="#42DBA1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M98.666 73.469h-39.94c8.004 15.002 23.435 25.45 41.399 26.446 6.651-.726 11.828-6.347 11.828-13.181 0-7.325-5.948-13.265-13.287-13.265Z"
          fill="#00A673"
        />
        <path
          d="M2.501 34.883c0-6.183.001-10.77.302-14.399.3-3.62.896-6.212 2.044-8.421a20.833 20.833 0 0 1 8.884-8.884c2.21-1.148 4.802-1.743 8.42-2.044 3.63-.301 8.217-.302 14.4-.302h30.234c6.183 0 10.77.001 14.399.302 3.62.301 6.212.896 8.42 2.044a20.834 20.834 0 0 1 8.885 8.884c1.148 2.21 1.743 4.802 2.044 8.421.301 3.63.302 8.216.302 14.4v30.233c0 6.183-.001 10.77-.302 14.399-.301 3.62-.896 6.212-2.044 8.421a20.834 20.834 0 0 1-8.884 8.884c-2.21 1.148-4.802 1.743-8.421 2.044-3.63.301-8.216.302-14.4.302H36.552c-6.183 0-10.77-.001-14.4-.302-3.618-.301-6.21-.896-8.42-2.044a20.834 20.834 0 0 1-8.884-8.884c-1.148-2.21-1.743-4.802-2.044-8.421-.301-3.63-.302-8.216-.302-14.4V34.884Z"
          stroke="#E6E6E6"
          strokeWidth={1.667}
        />
      </g>
    </svg>
  )
}

export default T01Logo
